import styled from "styled-components"
import useSound from 'use-sound'
import sound from '../assets/audio/eternal-youth.mp3'
import soundwaveLight from '../assets/audio/soundwave-light.json'
import soundwaveDark from '../assets/audio/soundwave-dark.json'
import Lottie from 'react-lottie'
import { ThemeContext } from 'styled-components'
import { useContext } from 'react'
import { MobileSize } from "../responsive/MobileSize"

const Container = styled.div`
    position: fixed;
    top: 10px;
    left: 150px;
    z-index: 3;
    color: ${props => props.theme.text};
    background-color: ${props => props.theme.body};
    border: 1px solid ${props => props.theme.text};
    padding: 0px 5px;
    border-radius: 10px;
    display: flex;
    align-items: center;
    cursor: pointer;
    ${MobileSize({ left: "10px", top: "60px", padding: "0px"})}
`

const Audio = ({ onClick,isPlay}) => {
  
  const [play, {stop}] = useSound(sound,{
    volume: 0.5,
  });
  isPlay ? play() : stop();

  const theme = useContext(ThemeContext);

  const defaultOptions = {
    loop: true,
    autoplay: true,
    animationData: theme.isLight ? soundwaveLight : soundwaveDark,
  };

  return (
    <Container onClick={onClick}>
      <span className="material-icons">{ isPlay ? "pause" : "play_arrow" }</span>
         <Lottie options={defaultOptions} height={50} width={60} isStopped={!isPlay}/>
    </Container>
  )
}

export default Audio